import { Table as AntdTable, type TableProps } from 'antd';
import type { VFC } from 'react';
import { SkeletonTable, type SkeletonTableColumnsType } from '../loading_skeletons/Table';

export function Table<T extends Record<string, any>>(props: TableProps<T>): ReturnType<VFC<TableProps<T>>> {
  const { loading, pagination, columns } = props;

  return (
    <>
      {loading ? (
        <SkeletonTable
          columns={columns as SkeletonTableColumnsType[]}
          rowCount={pagination ? pagination?.pageSize : 10}
        />
      ) : (
        <AntdTable {...props} />
      )}
    </>
  );
}
